import { ModifierSetDto } from "services/modifierSets/restModels";

// Бэк сортирует по русскому названию с откатом на любой заполненный перевод
// (ModifierSetsWarehouseService.sortName) — повторяем правило один в один, иначе на
// неруской локали кабинета порядок разошёлся бы с ответом сервера.
const PRIMARY_LOCALE = "ru";

const sortName = (name: Record<string, string>): string => {
    if (name[PRIMARY_LOCALE]) return name[PRIMARY_LOCALE];

    const filled = Object.keys(name).find((lang) => !!name[lang]);

    return filled ? name[filled] : "";
};

export const sortModifierSetsByName = (modifierSets: ModifierSetDto[]): ModifierSetDto[] =>
    [...modifierSets].sort((left, right) =>
        sortName(left.name).localeCompare(sortName(right.name), PRIMARY_LOCALE, {
            sensitivity: "base",
        })
    );
